export default function Message({ text }) {
  return <div className="col-span-12">{text}</div>;
}
